/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMViewLookEvent } from '@/data/events/handlers/gtm/ViewLook';
import { GTMViewLookPayload } from '@/data/types/GTM';

type ViewLookDelegatorProps = {
	gtm?: GTMViewLookPayload;
};

export const viewLookDelegator = async (payload: ViewLookDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMViewLookEvent(gtm);
	}
};
